import { render, staticRenderFns } from "./DetalleShow.vue?vue&type=template&id=1df36e7b"
import script from "./DetalleShow.vue?vue&type=script&lang=js"
export * from "./DetalleShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports